/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit, Output, Input, EventEmitter, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { MoveOrderConfimationModalComponent } from './move-order-confirmation-modal.component'
import { MoveOrderService } from './move-order.service';
import { MoveOrder } from './move-order.modal';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

@Component({
  selector: 'move-order',
  templateUrl: './move-order.component.html',
  styleUrls: ['./move-order.component.scss']
})

export class MoveOrderComponent implements OnInit {
  @Output() closeSlider: EventEmitter<any> = new EventEmitter();
  @Input() defaultParticipant: any;
  public validationObj = {
    userMessage: '',
    state: ''
  };
  public notificationOptions = {
    timeOut: 4000,
    showProgressBar: true,
    pauseOnHover: true,
    clickToClose: true,
    maxLength: 0,
    position: ["right", "top"]
  };
  public isFormSubmitted = false;
  public selectedDistributor: any;
  public distributorNotSelected = true;
  public order: any = {};
  public orderDtls: any = [];
  public translationsObj: any = {};
  public periods: any = [];
  public orders: any = [];
  public areOrdersFetchedFromAPI = false;
  public currentVolumes: any = {
    oldVolumes: [],
    newVolumes: []
  };
  public moveToPeriodVolumes: any = {
    oldVolumes: [],
    newVolumes: []
  };
  public movePeriodDtls: any = {};
  public currentPeriod: any = {};
  public defaultSearchText = '';
  public getPeriodsAPILoaded = false;
  public menuObj: any = {};
  public hasAccess = true;
  public currentPeriodRef: any = '';
  public isFromResprocess = false;
  public futurePeriod: any;
  private defaultConfig: ModalOptions = {
    backdrop: true,
    ignoreBackdropClick: true
  };

  constructor(private modalService: BsModalService,
    private toastr: ToastrService,
    public commonService: CommonService,
    private translate: TranslateService,
    private moveOrderService: MoveOrderService) {
    this.resetValidationErrorMessage();
    const menuId = this.commonService.getMenuId('MOVR');
      this.commonService.setHelpObj({
        header: this.getTranslationWithKey('MOVR') || '',
        menuId: menuId,
        sections: [],
        lastSavedData: [],
        relatedLinks: [
          {
            label: this.getTranslationWithKey('FLP'),
            url: '/fieldsupport/distributorList/default'
          }, {
            label: this.getTranslationWithKey('GLY'),
            url: '/genealogyHome/genealogy/default'
          }
        ]
      });
  }

  ngOnInit() {
    this.hasAccess = this.commonService.hasFeatureAccess('Move Order Volume');
    this.isFromResprocess = this.commonService.getReprocess();
    this.resetValidationErrorMessage();
    this.getCurrentPeriod();
    this.isFormSubmitted = false;
    const vm = this;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['defaultParticipant'] && changes['defaultParticipant'].currentValue) {
      this.defaultSearchText = changes['defaultParticipant'].currentValue?.clientId;
      if(this.currentPeriodRef){
        this.getPeriods();
      }else{
        this.getCurrentPeriod();
      }

    }
  }

  public getTranslationWithKey(key: string): string {
    return this.commonService.getTranslatedVal(key);
  }

  private getCurrentPeriod() {
    // Company Code Fix
    const companyCode = this.commonService.getCompanyCode();
    this.moveOrderService.getCurrentPeriod(companyCode)
      .then(this.currentPeriodDetailsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
  }

  private currentPeriodDetailsSH(response: any) {
    const responseMsg = response, user = '';
    if (responseMsg) {
      this.currentPeriodRef = responseMsg.name;
      this.getPeriods();
    }
  }

  private getPeriods() {
    if (!this.getPeriodsAPILoaded) { /*Restrict to call API only once */
      this.getPeriodsAPILoaded = true;
      this.moveOrderService.getPeriods({ hideLoader: true, fromReprocess: this.isFromResprocess })
        .then(this.getPeriodsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
    }
  }

  private getPeriodsSH(response: any) {
    let year, curPeriodIndex, vm = this, otherIndex: any;
    this.periods = response || [];
    this.periods.forEach((element: any, index: any) => {
      if (!element) return;
      year = (element.name) ? element.name.substring(0, 4) : '';
      if (element.name == vm.currentPeriodRef) {
        //if (element.current) {
        element.label = element.periodDefinition.name + ' ' + year + ' (' + this.getTranslationWithKey('current_period') + ')';
        element.currentPeriodName = element.periodDefinition.name + ' ' + year;
        this.currentPeriod = element;
        curPeriodIndex = index;
      } else {
        element.label = element.periodDefinition.name + ' ' + year + ' (' + (this.isFromResprocess ? this.getTranslationWithKey('previous_period') : this.getTranslationWithKey('future_period')) + ')';
        element.prevPeriodName = element.periodDefinition.name + ' ' + year;
        otherIndex = index;
      }
    });


    /* Removing current period from "Move To Period" list */
    // if (this.commonService.getReprocess()) {
    //   this.periods.splice(curPeriodIndex, 1);
    //   this.commonService.setReprocess(false);
    // }
    if(this.isFromResprocess){
      this.periods.splice(curPeriodIndex, 1);
    }else{
      this.futurePeriod = this.periods[otherIndex];
      this.periods.splice(otherIndex, 1);
    }
    // this.periods.splice(curPeriodIndex, 1);
    setTimeout(() => {
      this.order.moveToPeriod = this.periods[0];
    }, 100);

    if (this.defaultParticipant) { /*If "Move Order" is selected form DistributorDetails page, selected participant details should be autopopulted in slider*/
      this.distributorSelected(this.defaultParticipant);
    }

  }

  public distributorSelected(event: any) {
    let clientId;
    this.resetDtls();
    this.distributorNotSelected = false;
    this.selectedDistributor = event;
    if (this.selectedDistributor) {
      // distId = this.selectedDistributor.id;
      clientId = this.selectedDistributor?.clientId;
      this.setFullName(this.selectedDistributor);
      this.getPeriodDtls(clientId);
      this.areOrdersFetchedFromAPI = false;
      this.getCurrentOrders(clientId);
    }
  }

  private setFullName(distributor: any) {
    const firstName = distributor.firstName || "";
    const lastName = distributor.lastName || "";
    distributor.name = `${firstName} ${lastName}`
  }

  private getPeriodDtls(clientId: any) {
    if (this.isFromResprocess) {
      this.moveOrderService.getCommissionVolumes(clientId, this.order.moveToPeriod.name, false)
        .then(this.getPeriodDtlsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
    } else {
      this.moveOrderService.getPeriodDtls(this.order.moveToPeriod.name, clientId).then(this.getPeriodDtlsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
    }
  }

  private getPeriodDtlsSH(data: any) {
    this.movePeriodDtls = data;
  }

  private getCurrentOrders(clientId: any) {
    let periodName;
    if (this.isFromResprocess) {
      periodName = this.currentPeriod.name;
    } else {
      // periodName = this.getNextPeriodName(this.currentPeriod.name);
      periodName = this.futurePeriod.name;
    }
    this.moveOrderService.getCurrentOrders(periodName, clientId).then(this.getCurrentOrdersSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
  }

  // private getNextPeriodName(periodName) {
  //   let fPeriodName, year, month;
  //   month = periodName.substring(4, periodName.length);
  //   year = periodName.substring(0, 4);
  //   if (month == '12') {
  //     year = Number(year) + 1;
  //     month = 1;
  //   }
  //   else {
  //     month = Number(month) + 1;
  //   }
  //   if (Number(month) < 10) {
  //     month = "0" + month;
  //   }
  //   fPeriodName = year + month;
  //   return fPeriodName;
  // }

  private getCurrentOrdersSH(data: any) {
    this.areOrdersFetchedFromAPI = true;
    this.orders = data;
  }

  public orderChange(order: any) {
    let ppvVolume = 0, volumes = [];
    this.orderDtls = [
      // { label: this.translationsObj.orderingLeader, value: this.selectedDistributor.name },
      { label: this.getTranslationWithKey('order_period'), value: order.volumePeriod },
      { label: this.getTranslationWithKey('order_date'), value: order.orderDate, type: 'date' }
    ];

    if (order.businessLeader) {
      this.orderDtls.push({ label: this.getTranslationWithKey('ordering_leader_id'), value: order.businessLeader?.clientId });
    }
    volumes = JSON.parse(JSON.stringify(order.volumes));
    volumes.forEach((element: any) => {
      if (element.code == "PPV") {
        ppvVolume = element.value;
      }
      element.label = element.code;
    });

    this.orderDtls.push.apply(this.orderDtls, volumes);
    if(this.isFromResprocess){
      this.calculateCurrentVolumes(ppvVolume, this.selectedDistributor.position);
    }else{
      this.moveOrderService.getPeriodDtls(this.futurePeriod.name, this.selectedDistributor?.clientId).then((res: any) =>{
        this.calculateCurrentVolumes(ppvVolume, res['position']);
      });
    }
    this.calculateMovePeriodVolumes(ppvVolume);
  }

  private calculateCurrentVolumes(ppvVolume: any, positionDtls: any) {
    this.currentVolumes = {
      oldVolumes: [],
      newVolumes: []
    };
    const position = positionDtls;
    if (position && position.directVolumes && position.directVolumes.PPV) {
      this.pushCurrentVolumes("PPV", position.directVolumes.PPV, ppvVolume);
    }
    if (position && position.groupVolumes && position.groupVolumes.GPV) {
      this.pushCurrentVolumes("GPV", position.groupVolumes.GPV, ppvVolume);
    }
    if (position && position.sponsorVolumes && position.sponsorVolumes.OV) {
      this.pushCurrentVolumes("OV", position.sponsorVolumes.OV, ppvVolume);
    }
  }

  private pushCurrentVolumes(label: any, value: any, ppvVolume: any) {
    this.currentVolumes.oldVolumes.push({
      code: label,
      value: value
    });

    this.currentVolumes.newVolumes.push({
      code: label,
      value: (value - ppvVolume)
    });
  }

  private calculateMovePeriodVolumes(ppvVolume: any) {
    this.moveToPeriodVolumes = {
      oldVolumes: [],
      newVolumes: []
    };
    const position = this.movePeriodDtls.position;
    this.pushMovePeriodVolumes("PPV", ((position && position.directVolumes && position.directVolumes.PPV) ? position.directVolumes.PPV : 0), ppvVolume);
    this.pushMovePeriodVolumes("GPV", ((position && position.directVolumes && position.groupVolumes.GPV) ? position.groupVolumes.GPV : 0), ppvVolume);
    this.pushMovePeriodVolumes("OV", ((position && position.directVolumes && position.sponsorVolumes.OV) ? position.sponsorVolumes.OV : 0), ppvVolume);
  }

  private pushMovePeriodVolumes(label: any, value: any, ppvVolume: any) {
    this.moveToPeriodVolumes.oldVolumes.push({
      code: label,
      value: value
    });

    this.moveToPeriodVolumes.newVolumes.push({
      code: label,
      value: (value + ppvVolume)
    });
  }

  public clearSpecificDistFilter() {
    this.distributorNotSelected = true;
    this.isFormSubmitted = false;
    this.resetDtls();
  }

  private resetDtls() {
    this.orderDtls = [];
    this.order = {};
    this.orders = [];
    this.order.moveToPeriod = this.periods[0];
    this.order.currentPeriod = this.currentPeriod;
    this.currentVolumes = {
      oldVolumes: [],
      newVolumes: []
    };
    this.moveToPeriodVolumes = {
      oldVolumes: [],
      newVolumes: []
    };
  }

  public close() {
    this.isFormSubmitted = false;
    this.closeSlider.emit();
  }

  public submitMoveOrder() {
    this.isFormSubmitted = false;
    const initialState = {
      context: {
        order: this.order,
        futurePeriodLbl: this.futurePeriod ? this.futurePeriod.label : '',
        fromReprocess: this.isFromResprocess
      }
    };
    
    const modalRef: BsModalRef = this.modalService.show(MoveOrderConfimationModalComponent, {
      ...this.defaultConfig,
      initialState,
      class: 'modal-dialog modal-custom-width'
    });
    
    // Handle modal close event
    modalRef.content?.closeModal.subscribe((result: any) => {
      if (result) {
        this.moveOrderSubmitted(result);
      }
    });
    
    // Handle modal dismissal
    modalRef.onHide?.subscribe((err: any) => {
      this.moveOrderSubmitted(err);
    });
  }

  private resetValidationErrorMessage() {
    this.validationObj = {
      'userMessage': '',
      'state': ''
    };
  }


  public moveOrderSubmitted(result: any) {
    if (result === "confirmed") {
      this.order.transactionNo = '';
      const payload = this.createRequestPayload();
      this.moveOrderService.moveOrder(payload).then(this.moveOrderSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
    }
  }

  private createRequestPayload() {
    const payload = new MoveOrder(), selectedOrder = this.order.order;
    payload.order.volumeRecipient.clientId = this.selectedDistributor?.clientId;
    // payload.order.orderId = selectedOrder.orderId;
    payload.order.originalOrderId = selectedOrder.orderId;
    payload.order.volumes = selectedOrder.volumes;
    payload.order.volumes = selectedOrder.volumes;
    payload.order.volumePeriod = this.order.moveToPeriod.name;

    if (selectedOrder.businessLeader) {
      payload.order.businessLeader.clientId = selectedOrder.businessLeader?.clientId;
    } else {
      delete payload.order.businessLeader;
    }
    return payload;
  }

  private moveOrderSH(result: any) {
    this.resetValidationErrorMessage();
    this.order.transactionNo = result ? JSON.parse(JSON.stringify(result.orderId)) : '';
    this.isFormSubmitted = true;
    this.toastr.success(this.getTranslationWithKey('operation_success'), this.getTranslationWithKey('success'));
  }

  public startNewMoveOrder() {
    this.resetValidationErrorMessage();
    this.distributorNotSelected = true;
    this.selectedDistributor = null;
    this.isFormSubmitted = false;
    this.resetDtls();
  }
}
